import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES, services } from "../lib/data";

export default function Services() {
  const { t, lang } = useLang();
  return (
    <>
      <PageHero tag={t("services.tag")} title={t("services.title")} subtitle={t("services.subtitle")} image={IMAGES.chauffeur} />

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <div className="grid auto-rows-[minmax(220px,auto)] grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Star;
            const featured = i === 0 || i === 7;
            return (
              <Reveal
                key={s.key}
                delay={(i % 3) * 0.08}
                data-testid={`service-card-${s.key}`}
                className={`group flex flex-col justify-between border border-white/10 bg-matte-surface p-8 transition-all duration-500 hover:border-gold/40 ${featured ? "lg:col-span-2" : ""}`}
              >
                <div>
                  <Icon size={30} className="text-gold" strokeWidth={1.4} />
                  <h3 className="mt-6 font-display text-2xl text-white">{s[lang].title}</h3>
                  <p className="mt-3 max-w-md font-body text-sm leading-relaxed text-white/55">{s[lang].desc}</p>
                </div>
                <Link to="/booking" className="mt-8 inline-flex items-center gap-2 font-body text-xs uppercase tracking-[0.2em] text-gold opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  {t("common.bookNow")} <ArrowRight size={14} />
                </Link>
              </Reveal>
            );
          })}
        </div>

        <Reveal className="mt-16 flex flex-col items-center gap-6 border border-white/10 bg-matte-deep p-12 text-center">
          <h2 className="font-heading text-3xl text-white lg:text-4xl">{t("home.ctaTitle")}</h2>
          <Link to="/booking" data-testid="services-cta"
            className="inline-flex items-center gap-2 bg-gold px-10 py-4 font-body text-xs uppercase tracking-[0.2em] text-black transition-colors hover:bg-gold-muted">
            {t("common.requestQuote")} <ArrowRight size={16} />
          </Link>
        </Reveal>
      </section>
    </>
  );
}
